import React, { Component } from "react"
import { VariationContainer } from "components/variations/redux/VariationContainers"

export class VariationPage extends Component {
    render() { return (<VariationContainer />) }
}
